export const API_BASE_URL = 'https://api.dobrezpravydnes.cz/articles';
//export const API_BASE_URL = 'http://192.168.10.14:5000/articles';
